export default __webpack_public_path__ + "static/media/outside.4211b353.jpg";